import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

export const RootRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only redirect if we're at the root path
    if (location.pathname === '/') {
      // Get browser language or default to French
      const browserLang = navigator.language.split('-')[0];
      const supportedLangs = ['nl', 'fr', 'en', 'de'];
      const defaultLang = supportedLangs.includes(browserLang)
        ? browserLang
        : 'fr';

      // Preserve search parameters
      const searchString = location.search || '';

      // Redirect to the default language
      navigate(`/${defaultLang}${searchString}`, { replace: true });
    }
  }, [location.pathname, navigate, location.search]);

  return null;
};
